import React from "react";

import { Box, Stack, Typography } from "@mui/material";
import { DashboardNewsIcon } from "assets/material-custom-icons";
import { ArticleRow } from "store/types";
import { formatNewsDate } from "utils/format-news-date";

interface InvestmentsNewsProps {
  data: ArticleRow;
}

export const InvestmentsNews: React.FC<InvestmentsNewsProps> = ({ data }) => (
  <Stack
    component="a"
    href={data.url || undefined}
    target="_blank"
    rel="noopener noreferrer"
    direction="row"
    alignItems="flex-start"
    justifyContent="space-between"
    gap="12px"
    sx={{
      py: "12px",
      pr: "6px",
      borderBottom: "1px solid #E5E8EF",
      textDecoration: "none",
      color: "inherit",
      "&:last-child": { borderBottom: "none" },
      "&:hover .article-title": { color: "#26a6ae" }
    }}
  >
    <Stack direction="row" alignItems="flex-start" gap="10px" flex={1} minWidth={0}>
      <Box
        sx={{
          width: 28,
          height: 28,
          borderRadius: "6px",
          backgroundColor: "#EBF5F5",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          mt: "2px"
        }}
      >
        <DashboardNewsIcon sx={{ fontSize: 15, color: "#0B4549" }} />
      </Box>
      <Stack minWidth={0} flex={1}>
        <Typography
          className="article-title"
          sx={{
            fontSize: "13px",
            fontWeight: 500,
            color: "#252D39",
            lineHeight: 1.4,
            wordBreak: "break-word",
            transition: "color 0.12s"
          }}
        >
          {data.title}
        </Typography>
        {data.source && <Typography sx={{ fontSize: "12px", color: "#58667D", mt: "2px" }}>{data.source}</Typography>}
      </Stack>
    </Stack>
    <Typography
      sx={{
        fontSize: "12px",
        color: "#97A6BF",
        whiteSpace: "nowrap",
        flexShrink: 0,
        mt: "3px"
      }}
    >
      {formatNewsDate(data.published_at)}
    </Typography>
  </Stack>
);
